import { render, staticRenderFns } from "./scroll-number.vue?vue&type=template&id=bcb13c6c&scoped=true&"
import script from "./scroll-number.vue?vue&type=script&lang=js&"
export * from "./scroll-number.vue?vue&type=script&lang=js&"
import style0 from "./scroll-number.vue?vue&type=style&index=0&id=bcb13c6c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb13c6c",
  null
  
)

export default component.exports